export {default as quadtree} from "./src/quadtree";



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-quadtree/index.js
// module id = Bx0Q
// module chunks = 0